import { useQuery } from "@tanstack/react-query";
import { ApiResponse, ICategory, ILookupAPIResp, IUser } from "../../core/_models";
import { getLookupDataByKeys, ILookupDataResponse } from "../../core/_lookup_request";
import { QUERY_OPTIONS } from "../../../../utils/config";
import { getCategoryList } from "../../core/_request";
import { getStakeHolderGroupedDropdownData } from "./_request";
import { getUsers } from "./_user";

const defaultLookupResponse: ILookupAPIResp = { list: [], lookup: { display_name: "", dev_name: "" } };

export const useLookupData = (
  queryKey: string,
  lookupKeys: string[]
) => {
  return useQuery({
    queryKey: ["lookup", queryKey],

    queryFn: async () => {
      const response: ApiResponse<ILookupDataResponse> =
        await getLookupDataByKeys(lookupKeys);

      if (response.status !== "ok") {
        throw new Error(response.message);
      }

      return response.data;
    },

    ...QUERY_OPTIONS,
  });
};

export const useTeamMembersMasterDataQuery = () => {
  const rolesQuery = useLookupData("project-team-roles", ["project_team_roles"]);

  const users = useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const response: ApiResponse<{ list: IUser[] }> = await getUsers();
      if (response.status !== "ok") {
        throw new Error(response.message);
      }
      return response.data?.list ?? [];
    },
    ...QUERY_OPTIONS,
  });

  

  return {
    users: users.data ?? [],
    projectRoles: rolesQuery.data?.project_team_roles?.list ?? defaultLookupResponse.list,
    isLoading:
      users.isLoading ||
      rolesQuery.isLoading ||
      users.isLoading,
    isError: users.isError || rolesQuery.isError || users.isError,
    error: users.error || rolesQuery.error || users.error,
    refetch: users.refetch || rolesQuery.refetch,
  };
};

export const useDocumentCategoryQuery = () => {
  const categoriesQuery = useQuery({
    queryKey: ['categories', 'all_categories'],
    queryFn: async () => {
      const response: ApiResponse<{ list: ICategory[] }> =
        await getCategoryList();

      if (response.status !== 'ok') {
        throw new Error(response.message);
      }

      return response.data.list;
    },
    ...QUERY_OPTIONS,
  });

  return {
    categories: categoriesQuery.data ?? [],
    isLoading: categoriesQuery.isLoading,
    isError: categoriesQuery.isError,
    error: categoriesQuery.error,

    refetch: categoriesQuery.refetch,
  };
};

export const useStakeHolderGroupedDropdownDataQuery = () => {
  const stakeHoldersQuery = useQuery({
    queryKey: ['stakeHolders'],
    queryFn: async () => {
      const response =
        await getStakeHolderGroupedDropdownData();

      if (response.status !== 'ok') {
        throw new Error(response.message);
      }

      return response.data;
    },
    ...QUERY_OPTIONS,
  });

  return {
    stakeholderList: stakeHoldersQuery.data ?? [],
    isLoading: stakeHoldersQuery.isLoading,
    isError: stakeHoldersQuery.isError,
    error: stakeHoldersQuery.error,

    refetch: stakeHoldersQuery.refetch,
  };
}